import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class FocusModeOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.FOCUS_MODE)) {
      const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.FOCUS_MODE);
      deliveryOption.addSetting('value', 'true');
      provider.addDeliveryOption(deliveryOption);
    }
  }
}

export default FocusModeOptionHandler;
